<template>
    <div>
        <PurchaseOrderLinesTable
            :rows="purchaseOrders"
            :searchTerm.sync="searchTerm"
            :page="page"
            :length="length"
            :total="total"
            :loading="loading"
            :error="error"
            @search="searchPurchaseOrders"
            @clear="clearSearch"
            @refresh="loadPurchaseOrders"
            @page-change="changePage"
            @size-change="changeLength"
            @row-click="rowClick"
        />
        <PurchaseOrderForm ref="moduleForm" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import PurchaseOrderLinesTable from './LinesTable.vue';
import PurchaseOrderForm from './Form.vue';

export default {
    name: 'OpenPurchaseOrders',
    components: { PurchaseOrderLinesTable, PurchaseOrderForm },
    data() {
        return {
            connection: 'QATL_PRODUCTION',
            searchTerm: '',
            appliedTerm: '',
            purchaseOrders: [],
            page: 1,
            length: 25,
            total: 0,
            loading: false,
            error: '',
            requestId: 0
        };
    },
    mounted() {
        return this.loadPurchaseOrders();
    },
    beforeDestroy() {
        this.requestId += 1;
    },
    methods: {
        ...mapActions('OpenPurchaseOrderModule', ['listPurchaseOrderLines']),
        rowClick(row) {
            return this.$refs.moduleForm.openDialog(row, this.connection);
        },
        async loadPurchaseOrders() {
            const requestId = ++this.requestId;
            this.loading = true;
            this.error = '';
            this.purchaseOrders = [];
            try {
                const response = await this.listPurchaseOrderLines({
                    connection: this.connection,
                    term: this.appliedTerm,
                    page: this.page,
                    length: this.length
                });
                if (requestId !== this.requestId) return;
                if (!response || !Array.isArray(response.data) || !response.meta
                    || !Number.isFinite(Number(response.meta.total))) {
                    throw new Error('Invalid purchase order line list response');
                }
                this.purchaseOrders = response.data;
                this.total = Number(response.meta.total);
            } catch (error) {
                if (requestId !== this.requestId) return;
                this.error = 'Unable to load purchase orders. Please try Refresh again.';
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        },
        searchPurchaseOrders() {
            if (this.searchTerm.length > 100) {
                this.error = 'Search must be at most 100 characters.';
                return;
            }
            this.appliedTerm = this.searchTerm.trim();
            this.page = 1;
            this.total = 0;
            return this.loadPurchaseOrders();
        },
        clearSearch() {
            this.searchTerm = '';
            return this.searchPurchaseOrders();
        },
        changePage(page) {
            this.page = page;
            return this.loadPurchaseOrders();
        },
        changeLength(length) {
            this.length = length;
            this.page = 1;
            return this.loadPurchaseOrders();
        }
    }
};
</script>
